import Modal from 'react-bootstrap/Modal';
import './index.css';

const  ModalTemplate = ({show, onHide, title, children}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size='lg'
      aria-labelledby="contained-modal-title-vcenter"
      centered 
    >
      <Modal.Header className='header_modal_template'>
        <div>
          {title}
        </div>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
    </Modal>
  );
}

export default ModalTemplate;